export class ReportMonthDateRange {
    constructor(
        public monthYear:string
    ){

    }
}
